import React from 'react';
import {Modal} from 'antd';
import styled from 'styled-components';

export default function WidgetModal({
  open,
  onCancel,
  closeIcon = true,
  height,
  contentDivider = true,
  title,
  content,
  ...props
}) {
  return (
    <StyledModal
      open={open}
      onCancel={onCancel}
      type="primary"
      closeIcon={closeIcon}
      height={height}
      contentDivider={contentDivider}
      title={title}
      {...props}>
      {content}
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  .ant-modal-close {
    color: #212224;
    display: ${({closeIcon}) => (closeIcon ? 'block' : 'none')};
    top: 24px;
    right: 24px;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-header {
    padding: 24px 24px 16px;
    border-radius: 10px 10px 0 0;
    border-bottom: none;
    .ant-modal-title {
      display: ${({title}) => (title ? 'block' : 'none')};
      font-size: 20px;
      font-weight: 700;
      color: #25272c;
    }
  }
  .ant-modal-body {
    padding: 0 24px;
    font-size: 16px;
    height: ${({height}) => height || 'auto'};
    overflow-y: auto;
    color: #39393b;
  }
  .ant-modal-footer {
    border-top: ${({contentDivider}) =>
      contentDivider ? '1px solid #f0f0f0' : 'none'};
    margin-top: 0;
    padding: 24px;
  }
`;
